// Легкий стеммер UA/RU для розумного пошуку: обрізає закінчення родів/
// відмінків/числа, щоб «задня», «задній», «заднее» зводилися до спільного
// кореня «задн». Навмисно консервативний ( максимум один суфікс, основа
// від 3 символів): точність важливіша за глибину, збіг далі перевіряється
// префіксним правилом і класами синонімів (synonyms.ts).
const SUFFIXES = [
    'иями',
    'ями',
    'ами',
    'ові',
    'еві',
    'ого',
    'его',
    'ому',
    'ему',
    'ими',
    'ыми',
    'ах',
    'ях',
    'ей',
    'ой',
    'ий',
    'ый',
    'ій',
    'їй',
    'ая',
    'яя',
    'ое',
    'ее',
    'ую',
    'юю',
    'ії',
    'ої',
    'ов',
    'ев',
    'ок',
    'і',
    'и',
    'ы',
    'а',
    'я',
    'у',
    'ю',
    'е',
    'о',
    'ь',
].sort((a, b) => b.length - a.length);
export function stemWord(word) {
    const w = word.toLowerCase().replace(/ё/g, 'е').replace(/ї/g, 'і');
    if (w.length <= 3)
        return w;
    let stem = w;
    for (const suf of SUFFIXES) {
        if (stem.length - suf.length >= 3 && stem.endsWith(suf)) {
            stem = stem.slice(0, -suf.length);
            break;
        }
    }
    // м'який знак лишився після суфікса («заднього» → «заднь»): прибираємо,
    // інакше родовий відмінок не зведеться з називним
    if (stem.endsWith('ь') && stem.length - 1 >= 3) {
        stem = stem.slice(0, -1);
    }
    return stem;
}
/** Канонічна нормалізація тексту: регістр, ё/ї, пунктуація → пробіли. */
export function normalizeText(text) {
    return text
        .toLowerCase()
        .replace(/ё/g, 'е')
        .replace(/ї/g, 'і')
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
//# sourceMappingURL=stem.js.map